<template>
    <v-app>
        <v-app-bar
            app
            color="#F24653"
            dark
            dense
        >
            <v-toolbar-title>
                <slot name="title">RedChirp Chat Widget: Google Tag Manager</slot>
            </v-toolbar-title>
        </v-app-bar>
        <v-container>
            <v-card
                style="margin-top: 60px"
            >
                <v-card-text class="help_text">
                    <p>
                        The RedChirp Chat Widget supports easy integration with Google Tag Manager. Simply deploy the container <code>GTM-TXPXJK2</code> on your site
                        to begin serving the chat widget (pixel) code.
                    </p>
                    <p>
                        Many website providers, including Wix, Squarespace, Shopify, etc. have a built in way to deploy a Google Tag Manager container. For instructions, or to see if your provider has built in support for a Google Tag Manager deployment, just google "Wix Google Tag Manager" (or the appropriate website provider) and follow the instructions.
                        If you wish to deploy this container manually, place the following code as high in the <b>&lt;head&gt;</b> of each page as possible:
                    </p>
                </v-card-text>
                <div
                    class="script_style"
                >
                    <m-code-block>
                        &lt;!-- Google Tag Manager --&gt;
                        &lt;script&gt;(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                        j=d.createElement(s),dl=l!='dataLayer'?'&amp;l='+l:'';j.async=true;j.src=
                        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                        })(window,document,'script','dataLayer','GTM-TXPXJK2');&lt;/script&gt;
                        &lt;!-- End Google Tag Manager --&gt;
                    </m-code-block>
                </div>
                <v-card-text class="help_text">
                    Additionally, paste this code immediately after the opening <b>&lt;body&gt;</b> tag:
                </v-card-text>
                <div
                    class="script_style"
                >
                    <m-code-block>
                        &lt;!-- Google Tag Manager (noscript) --&gt;
                        &lt;noscript&gt;&lt;iframe src=&quot;https://www.googletagmanager.com/ns.html?id=GTM-TXPXJK2&quot;
                        height=&quot;0&quot; width=&quot;0&quot; style=&quot;display:none;visibility:hidden&quot;&gt;&lt;/iframe&gt;&lt;/noscript&gt;
                        &lt;!-- End Google Tag Manager (noscript) --&gt;
                    </m-code-block>
                </div>
            </v-card>
        </v-container>
    </v-app>
</template>

<script>

export default {
}
</script>

<style lang="scss" scoped>
.help_text {
    font-family: Roboto;
    font-size: 15px;
}
.script_style {
    padding-left: 15px;
    padding-right: 15px;
    overflow: auto;
}
</style>